import { render, staticRenderFns } from "./access-website.vue?vue&type=template&id=1783f15b&scoped=true"
import script from "./access-website.vue?vue&type=script&lang=js"
export * from "./access-website.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1783f15b",
  null
  
)

export default component.exports